import React from 'react';
import styled from 'styled-components';
import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay';
import { Img, Icon, Button } from 'components';
import { Section, RowBox, Box, Text } from 'styles';

export function Section7(props) {
  // issue#12326: change confirm dialog button
  // 3가지 테마 데이터 설정
  const cardData = [
    { id: 1, title: "🍔 내가 찾는 햄버거⋯", topColor: "#FF816E", theme: "mint", badgeText: "응답 완료 시",
      imgSrc: "surveyThumbnail01", mImgSrc: "moSurveyThumbnail01"
    },
    { id: 2, title: "나만의 음악 발견법⋯", topColor: "#FFEEAA", theme: "mint", badgeText: "응답 완료 시",
      imgSrc: "surveyThumbnail02", mImgSrc: "moSurveyThumbnail02"
    },
    { id: 3, title: "대중교통비 환급 지⋯", topColor: "#51E9C9", theme: "mint", badgeText: "응답 완료 시",
      imgSrc: "surveyThumbnail03", mImgSrc: "moSurveyThumbnail03"
    },
    { id: 4, title: "문화생활 취향 분석", topColor: "#51E9C9", theme: "red", badgeText: "응답 마감",
      imgSrc: "surveyThumbnail04", mImgSrc: "moSurveyThumbnail04"
    },
    { id: 5, title: "디저트 트렌드: '식⋯", topColor: "#51E9C9", theme: "red", badgeText: "응답 마감",
      imgSrc: "surveyThumbnail05", mImgSrc: "moSurveyThumbnail05"
    },
  ];

  // Duplicate slides so Embla has enough content for a seamless circular loop
  const slides = [...cardData, ...cardData, ...cardData];

  const [emblaRef] = useEmblaCarousel(
    { loop: true, align: 'start', slidesToScroll: 1 },
    [Autoplay({ delay: 3000, stopOnInteraction: false })]
  );

  return (
    <Section $backgroundColor="primary10">
      <Box $padding="80px 40px" $mPadding="40px 20px" $margin="auto">
        <Box $width="fit-content" $margin="auto">
          <Button $type="badge">
            <Icon name="badgeIcon" />
            Live Surveys
          </Button>
        </Box>
        <Text $type="b40" $mType="b28" $padding="24px 0 16px" $textAlign="center">
          지금 참여 가능한 설문
        </Text>
        <Text $type="18" $mType="16" $textAlign="center" $color="gray600">
          지금 바로 참여하고 리워드를 받아보세요
        </Text>
        <CarouselWrapper>
          <CarouselViewport ref={emblaRef}>
            <CarouselTrack>
              {slides.map((card, index) => (
                <CarouselSlide key={index}>
                  <CardContainer $topColor={card.topColor} $padding="24px">
                    <Box $borderRadius="16px" style={{ overflow: 'hidden' }}>
                      <Img desktopSrc={card.imgSrc} mobileSrc={card.mImgSrc} $width="100%" />
                    </Box>
                    <Box $padding="24px 0 16px">
                      <Text $type="b20" $color="gray900" $maxLine="1" $lineHeight="1.75">{card.title}</Text>
                      <Text $type="16" $color="gray600">1분 소요 · 4문항</Text>
                    </Box>
                    <hr style={{ border: 'none', borderTop: '1px solid #f0f0f0', margin: '16px 0' }} />
                    <RowBox $justifyContent="flex-start" $gap={12} $alignItems="center">
                      <Button $type="badge" $color={card.theme}>
                        {card.badgeText}
                      </Button>
                      <Text $type="b16" $color="gray900">10 T플러스포인트 적립</Text>
                    </RowBox>
                  </CardContainer>
                </CarouselSlide>
              ))}
            </CarouselTrack>
          </CarouselViewport>
        </CarouselWrapper>
      </Box>
    </Section>
  );
}

const CarouselWrapper = styled.div`
  position: relative;
  padding: 64px 0;

  @media only screen and (max-width: 767px) {
    padding: 32px 0;
  }
`;

const CarouselViewport = styled.div`
  overflow: hidden;
`;

const CarouselTrack = styled.div`
  display: flex;
  gap: 24px;
  padding-top: 10px;
  padding-bottom: 10px;
`;

const CarouselSlide = styled.div`
  flex: 0 0 calc(25% - 18px);
  min-width: 0;

  @media only screen and (max-width: 1023px) {
    flex: 0 0 calc(50% - 12px);
  }

  @media only screen and (max-width: 767px) {
    flex: 0 0 100%;
  }
`;

const CardContainer = styled.div`
  background: white;
  border-radius: 32px;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  border-top: 6px solid ${({ $topColor }) => $topColor};
  padding: ${({ $padding }) => $padding || '24px'};
  height: 100%;
  box-sizing: border-box;
`;